/* eslint-disable react/prop-types */
import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "wouter";
import { z } from "zod";

import { useForm } from "../../hooks/useForm";
import { getDealerBasePath } from "../../navigation/getDealerBasePath";
import { PrimaryButton } from "../../ui/Button/Button";
import { PartNuberInput } from "./inputs/PartNuberInput";

const schema = z.object({
  partNumber: z.string().nonempty({ message: "form.error.partNumber" }),
});

export const PartNumber: FunctionComponent = () => {
  const { t } = useTranslation();
  const [, setLocation] = useLocation();
  const [handleForm] = useForm({
    onSubmit({ partNumber }) {
      const basePath = getDealerBasePath();
      const nextPath = `${basePath}/search/partnumber-search/${partNumber}`;
      setLocation(nextPath);
    },
    schema,
  });
  return (
    <form
      className={clsx("grid sm:grid-cols-2 xl:flex gap-2")}
      noValidate
      onSubmit={handleForm}
    >
      <PartNuberInput />
      <PrimaryButton
        aria-label="viewResults"
        className="shrink-0 shadow-lg h-12 md:h-14"
        type="submit"
      >
        {t("searchForm.viewResults")}
      </PrimaryButton>
    </form>
  );
};
